/**
 * 不符合帕斯卡命名规范的组件映射
 */
export const NON_PASCAL_CASE_NAMES: Record<string, string> = {
  qrcode: 'QRCode',
};

export const WEB_COMPONENT_MAP: Record<string, string[]> = {
  affix: ['Affix'],
  alert: ['Alert'],
  anchor: ['Anchor', 'AnchorItem', 'AnchorTarget'],
  'auto-complete': ['AutoComplete', 'HighlightOption'],
  avatar: ['Avatar', 'AvatarGroup'],
  'back-top': ['BackTop'],
  badge: ['Badge'],
  breadcrumb: ['Breadcrumb', 'BreadcrumbItem'],
  button: ['Button'],
  calendar: ['Calendar'],
  card: ['Card'],
  cascader: ['Cascader', 'CascaderPanel'],
  checkbox: ['Checkbox', 'CheckboxGroup'],
  collapse: ['Collapse', 'CollapsePanel'],
  'color-picker': ['ColorPicker', 'ColorPickerPanel'],
  comment: ['Comment'],
  'config-provider': ['ConfigProvider'],
  'date-picker': ['DatePicker', 'DatePickerPanel', 'DateRangePicker', 'DateRangePickerPanel'],
  descriptions: ['Descriptions', 'DescriptionsItem'],
  dialog: ['Dialog', 'DialogPlugin'],
  divider: ['Divider'],
  drawer: ['Drawer', 'DrawerPlugin'],
  dropdown: ['Dropdown', 'DropdownItem', 'DropdownMenu'],
  empty: ['Empty'],
  form: ['Form', 'FormItem', 'FormList'],
  grid: ['Row', 'Col'],
  guide: ['Guide'],
  icon: ['Icon'],
  image: ['Image'],
  'image-viewer': ['ImageViewer'],
  input: ['Input', 'InputGroup'],
  'input-adornment': ['InputAdornment'],
  'input-number': ['InputNumber'],
  layout: ['Layout', 'Aside', 'Content', 'Footer', 'Header'],
  link: ['Link'],
  list: ['List', 'ListItem', 'ListItemMeta'],
  loading: ['Loading', 'LoadingPlugin'],
  menu: ['Menu', 'MenuGroup', 'MenuItem', 'HeadMenu', 'Submenu'],
  message: ['Message', 'MessagePlugin'],
  notification: ['Notification', 'NotifyPlugin'],
  pagination: ['Pagination', 'PaginationMini'],
  popconfirm: ['Popconfirm'],
  popup: ['Popup'],
  progress: ['Progress'],
  qrcode: ['QRCode'],
  radio: ['Radio', 'RadioButton', 'RadioGroup'],
  'range-input': ['RangeInput', 'RangeInputPopup'],
  rate: ['Rate'],
  select: ['Select', 'Option', 'OptionGroup'],
  'select-input': ['SelectInput'],
  skeleton: ['Skeleton'],
  slider: ['Slider', 'SliderButton'],
  space: ['Space'],
  statistic: ['Statistic'],
  steps: ['Steps', 'StepItem'],
  'sticky-tool': ['StickyTool', 'StickyItem'],
  switch: ['Switch'],
  swiper: ['Swiper', 'SwiperItem'],
  table: ['Table', 'BaseTable', 'EnhancedTable', 'PrimaryTable'],
  tabs: ['Tabs', 'TabPanel'],
  tag: ['Tag', 'CheckTag', 'CheckTagGroup'],
  'tag-input': ['TagInput'],
  textarea: ['Textarea'],
  'time-picker': ['TimePicker', 'TimePickerPanel', 'TimeRangePicker'],
  timeline: ['Timeline', 'TimelineItem'],
  tooltip: ['Tooltip', 'TooltipLite'],
  transfer: ['Transfer'],
  tree: ['Tree'],
  'tree-select': ['TreeSelect'],
  typography: ['Typography', 'Text', 'Title', 'Paragraph'],
  upload: ['Upload'],
  watermark: ['Watermark'],
};

export const MOBILE_COMPONENT_MAP: Record<string, string[]> = {
  'action-sheet': ['ActionSheet', 'ActionSheetPlugin'],
  avatar: ['Avatar', 'AvatarGroup'],
  'back-top': ['BackTop'],
  badge: ['Badge'],
  button: ['Button'],
  calendar: ['Calendar'],
  cascader: ['Cascader'],
  cell: ['Cell', 'CellGroup'],
  checkbox: ['Checkbox', 'CheckboxGroup'],
  collapse: ['Collapse', 'CollapsePanel'],
  'color-picker': ['ColorPicker'],
  'config-provider': ['ConfigProvider'],
  'count-down': ['CountDown'],
  'date-time-picker': ['DateTimePicker'],
  dialog: ['Dialog', 'DialogPlugin'],
  divider: ['Divider'],
  drawer: ['Drawer', 'DrawerPlugin'],
  'dropdown-menu': ['DropdownMenu', 'DropdownItem'],
  empty: ['Empty'],
  fab: ['Fab'],
  footer: ['Footer'],
  form: ['Form', 'FormItem'],
  grid: ['Grid', 'GridItem'],
  guide: ['Guide'],
  icon: ['Icon'],
  image: ['Image'],
  'image-viewer': ['ImageViewer'],
  indexes: ['Indexes', 'IndexesAnchor'],
  input: ['Input'],
  layout: ['Row', 'Col'],
  link: ['Link'],
  list: ['List'],
  loading: ['Loading', 'LoadingPlugin'],
  message: ['Message', 'MessagePlugin'],
  navbar: ['Navbar'],
  'notice-bar': ['NoticeBar'],
  overlay: ['Overlay'],
  picker: ['Picker'],
  popover: ['Popover'],
  popup: ['Popup'],
  progress: ['Progress'],
  'pull-down-refresh': ['PullDownRefresh'],
  qrcode: ['QRCode'],
  radio: ['Radio', 'RadioGroup'],
  rate: ['Rate'],
  result: ['Result'],
  search: ['Search'],
  'side-bar': ['SideBar', 'SideBarItem'],
  skeleton: ['Skeleton'],
  slider: ['Slider'],
  stepper: ['Stepper'],
  steps: ['Steps', 'StepItem'],
  sticky: ['Sticky'],
  'swipe-cell': ['SwipeCell'],
  swiper: ['Swiper', 'SwiperItem'],
  switch: ['Switch'],
  'tab-bar': ['TabBar', 'TabBarItem'],
  table: ['Table'],
  tabs: ['Tabs', 'TabPanel'],
  tag: ['Tag', 'CheckTag'],
  textarea: ['Textarea'],
  toast: ['Toast', 'ToastPlugin'],
  'tree-select': ['TreeSelect'],
  upload: ['Upload'],
};

export const CHAT_COMPONENT_MAP: Record<string, string[]> = {
  attachments: ['Attachments'],
  'chat-actionbar': ['ChatActionbar', 'ChatAction'], // vue-chat: ChatAction 改名 ChatActionbar,保留 ChatAction 用于兼容，后续版本将移除
  'chat-content': ['ChatContent'],
  'chat-input': ['ChatInput'], // vue-chat: 后续版本将移除
  'chat-item': ['ChatItem'], // vue-chat: 后续版本将移除
  'chat-list': ['ChatList', 'Chat'], // vue-chat: Chat 改名 ChatList, 保留 Chat 用于兼容，后续版本将移除
  'chat-loading': ['ChatLoading'],
  'chat-markdown': ['ChatMarkdown'],
  'chat-message': ['ChatMessage'],
  'chat-reasoning': ['ChatReasoning'], // vue-chat: 后续版本将移除
  'chat-sender': ['ChatSender'],
  'chat-thinking': ['ChatThinking'],
  chatbot: ['Chatbot'],
  'chat-engine': ['useChat', 'useAgentToolcall', 'useAgentState'],
};
